export const buildInfo = {version: '2505.11.0', release: '19c9c08e37c467773c53c34dba9e039592aba21f'};
